export const DATE_FORMAT_DISPLAY = 'YYYY年MM月DD日';
export const MOTH_FORMAT = 'YYYY年MM';
export const DATE_FORMAT = 'YYYY/MM/DD';
export const DATE_TIME_FORMAT = 'YYYY/MM/DD HH:mm:ss';
export const TIME_FORMAT = 'HH:mm:ss';
export const YEAR_MONTH_FORMAT = 'YYYY/MM';
